import styled from "styled-components";

interface IContainerProps {
    type: "success"|"danger";
}

export const Container = styled.div<IContainerProps>`
    padding: 15px;
    background-color: ${props=> props.type === 'success' ? props.theme.colors.success :  props.type === 'danger' ? props.theme.colors.danger : ""};
    color: ${props=> props.type === 'success' ? props.theme.textColor.success :  props.type === 'danger' ? props.theme.textColor.danger : ''};
    border-left: 6px solid ${props=> props.type === 'success' ? props.theme.colors.borderSuccess :  props.type === 'danger' ? props.theme.colors.borderDanger : ""};
    width: 100%;
`;